import { GridColumnConfig } from "../../../../../models/gridCoumnConfig";

export const contactTaskColumns: GridColumnConfig[] = [
  {
    title: 'Select',
    field: 'select',
    filter: 'text',
    width: "100px",
    searchable: true,
    isGroupable: false,
    isHideColumnMenu: true
  },
  {
    title: 'Contact Name',
    field: 'contactsFullName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Contact Email',
    field: 'contactsWorkEmail',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Contact Role',
    field: 'contactsRoleName',
    filter: 'text',
    searchable: true,
  },
];
